import React from 'react';
import _ from 'lodash';
import Picture from '../Picture.jsx';
import ContentMeta from '../ContentMeta.jsx';
import ArticleLink from '../ArticleLink.jsx';

export default class FeedContainerSmall extends React.PureComponent {
  render() {
    const { contentContainer } = this.props;
    const img = _.get(contentContainer, 'pictures[0].data.url') || _.get(contentContainer, 'videos[0].data.posterUrl');
    return (
      <div className="feed-container-small row search-list-item">
        <div className="col-sm-5">
          <ArticleLink className="article-image" contentContainer={contentContainer}>
            <Picture src={img} alt={contentContainer.title} size="2" />
          </ArticleLink>
        </div>
        <div className="col-sm-7">
          <ArticleLink className="text-colored-link" contentContainer={contentContainer}>
            <h4>
              {contentContainer.title}
            </h4>
            <p>{contentContainer.preamble}</p>
          </ArticleLink>
          <ContentMeta data={contentContainer} />
        </div>
      </div>
    );
  }
}

FeedContainerSmall.propTypes = {
  contentContainer: React.PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/component/Search/SearchListItem.jsx